<template>
  <div class="button-container">
    <div v-show="!isHideTracing" class="help-block-container w100">
      <el-button type="primary" @click="onClickActionButton('trace')">
        <div class="action-button">
          <IconTrace />
          {{ $t('Trace') }}
        </div>
      </el-button>
    </div>
  </div>
</template>
<script lang="ts">
import IconTrace from '@/components/svg/IconTrace.vue'
import { EDisplaySetting } from '@/utils/enums'
import { isHideVisibilityConfig } from '@/utils/helpers'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'
import { IBarcode } from '@/utils/types/barcodeTypes'
import { IBarcodeDefinitionType } from '@/utils/types/fieldDefinition'
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'

@Options({
  components: {
    IconTrace,
  },
  emits: ['update:loading'],
  name: 'DetailPageButtons',
})
export default class DetailPageButtons extends Vue {
  @Prop({ type: Object }) readonly barcodeTypeInfo!: IBarcodeDefinitionType
  @Prop({ type: Object }) readonly barcode!: IBarcode
  @Prop({ type: String }) readonly currentTrackPointKey!: string

  @PropSync('loading', { type: Boolean }) _loading!: boolean

  get isAuth() {
    return this.$store.getters.isAuth
  }

  get isHideTracing(): boolean {
    const visibility = this.barcodeTypeInfo?.uiConfig?.tracingVisibility || EDisplaySetting.HIDDEN
    return isHideVisibilityConfig(visibility, this.isAuth)
  }

  get projectParam() {
    return this.$store.getters.projectParam
  }

  onClickActionButton(view: string, id?: string) {
    this.$router.push({
      name: view,
      params: {
        project: this.projectParam,
        barcodeId: id || this.barcode?.id,
      },
    })
  }

  get isKeyenceEnterpriseBrowser() {
    return isKeyenceEnterpriseBrowser()
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixins.scss';

.button-container {
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
}

.help-block-container {
  position: relative;
  box-sizing: border-box;
  padding: 0.5rem;

  button {
    width: 100%;
  }

  &__child {
    bottom: 0rem;
    right: 0;
    position: absolute;
  }
}

.w100 {
  flex: 1 0 100%;
}

.dialog-area :deep() {
  .el-dialog__header {
    padding: 20px;
    text-align: left;
    background-color: #525252;

    .el-dialog__title {
      color: #ffffff;
    }
  }

  .el-dialog__body {
    word-break: normal;
  }

  .el-dialog__headerbtn {
    background-color: #ffffff;
    border-radius: 50%;
    min-width: 28px;
    min-height: 28px;
    width: 28px !important;
    height: 28px !important;
  }

  .barcode-label-container {
    display: flex;
    padding: 5px;
    margin: 0px;

    .action-menu {
      width: auto;
    }
  }
}

.activation-data-content {
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  word-break: keep-all;
  text-align: center;
  color: #000000;
}

.dialog-content-data {
  font-family: 'Noto Sans', sans-serif;
  width: 100%;

  &__id {
    color: #979797;
  }

  &__key-value-item {
    padding: 4px;
    display: flex;
    color: black;

    div:first-child {
      text-align: right;
      margin-right: 5px;
      flex-basis: 50%;
      min-width: 50%;
    }

    div:last-child {
      text-align: left;
    }
  }
}

.cancel-button {
  min-width: 120px;
  background-color: #c4c4c4;
  color: #ffffff;

  &.is-round {
    height: 64px;
    border-radius: 40px !important;
    box-sizing: border-box !important;
  }
}

.instock-btn {
  background-color: #219653 !important;
  border-color: #219653 !important;
  color: $pure-white;

  &.is-disabled {
    background-color: #7fb897;
    border-color: #7fb897;
  }
}

.outstock-btn {
  background-color: #9b80d5 !important;
  border-color: #9b80d5 !important;
  color: $pure-white;
}

.outstock-disabled-btn {
  background-color: #beace4 !important;
  border-color: #beace4 !important;
  color: $pure-white;
}

.ok-btn {
  width: 64px;
  height: 64px;
  background: #525252;
  color: #ffffff;

  &.is-round {
    height: 64px;
    border-radius: 40px !important;
    box-sizing: border-box !important;
  }
}

:deep(.el-collapse-item__content) {
  padding-bottom: 0px !important;
}

:deep(.el-collapse-item__header) {
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  background-color: #60a5fa;
}

.pair-history-collapse-scroll {
  max-height: 70vh;
  overflow-y: auto;
}

.label-box-custom {
  font-size: 14px;
  min-width: 50px;
  padding: 2px 8px;
  margin-right: 6px;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  line-height: 20px;
  display: inline-block;
  font-weight: 500;
  width: 80px;
  text-align: left;
}
</style>
